import { render, staticRenderFns } from "./AddMedicine.vue?vue&type=template&id=edc60496&scoped=true"
import script from "./AddMedicine.vue?vue&type=script&lang=js"
export * from "./AddMedicine.vue?vue&type=script&lang=js"
import style0 from "./AddMedicine.vue?vue&type=style&index=0&id=edc60496&prod&lang=scss&scoped=true"
import style1 from "./AddMedicine.vue?vue&type=style&index=1&id=edc60496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc60496",
  null
  
)

export default component.exports